import { render, staticRenderFns } from "./HealthGroup.vue?vue&type=template&id=49e6114e&scoped=true"
import script from "./HealthGroup.vue?vue&type=script&lang=js"
export * from "./HealthGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e6114e",
  null
  
)

export default component.exports